var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { jsx } from 'theme-ui';
import Box from './Box';
/**
 * @param {object} props
 * @param {boolean} [props.fluid]
 
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement}
 */
function Container(_a, ref) {
    var { fluid } = _a, rest = __rest(_a, ["fluid"]);
    return (jsx(Box, Object.assign({ ref: ref, sx: {
            maxWidth: fluid
                ? undefined
                : [
                    'container.mobile',
                    'container.tablet',
                    'container.default',
                    'container.large',
                ],
            marginX: 'auto',
            paddingX: 'gutter',
            boxSizing: 'border-box',
        } }, rest)));
}
export default React.forwardRef(Container);
//# sourceMappingURL=Container.js.map